import React, { Component } from "react";
import { Grid, Icon, Container, Header } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { APP_NAME } from "../../constants/resource.constants";
import {
  FACKBOOK_LINK,
  TWITTER_LINK,
  INSTAGRAM_LINK,
  EMAIL_LINK,
  BASE_URL
} from "../../constants/route.constants";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.handleLinkClick = this.handleLinkClick.bind(this);

    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  handleLinkClick(url, openInNewTab) {
    const tab = openInNewTab ? "_blank" : "_self";
    const win = window.open(url, tab);
    win.focus();
  }

  render() {
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container text>
          <Helmet>
            <title>Contact Us | {APP_NAME}</title>
            <meta
              name="description"
              content="Get in touch with GAA International via email, facebook, twitter or instagram."
            />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta property="og:title" content={`Contact Us | ${APP_NAME}`} />
            <meta
              property="og:description"
              content="Get in touch with GAA International via email, facebook, twitter or instagram."
            />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
          </Helmet>
          <Header as="h1">Contact Us</Header>
          <p>
            We would love to hear from you. Please get in touch with feedback,
            comments, questions, improvements or just to say hello.
          </p>
          <Grid columns={4} doubling={true} textAlign="center">
            <Grid.Column width={4}>
              <Icon
                circular
                inverted
                color="yellow"
                name="mail outline"
                size="huge"
                link={true}
                onClick={() => {
                  this.handleLinkClick(EMAIL_LINK, false);
                }}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Icon
                circular
                inverted
                color="blue"
                name="facebook f"
                size="huge"
                link={true}
                onClick={() => {
                  this.handleLinkClick(FACKBOOK_LINK, true);
                }}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Icon
                circular
                inverted
                color="blue"
                name="twitter"
                size="huge"
                link={true}
                onClick={() => {
                  this.handleLinkClick(TWITTER_LINK, true);
                }}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Icon
                circular
                inverted
                color="pink"
                name="instagram"
                size="huge"
                link={true}
                onClick={() => {
                  this.handleLinkClick(INSTAGRAM_LINK, true);
                }}
              />
            </Grid.Column>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

ContactPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/ContactPage/View.js